import React, { useState } from "react";
import '../styles/Lander.css';
import Header from "../components/Header";
import Form from "../components/Form";
import Success from "../components/Success";
const Lander = () => {
    const [success, setSuccess] = useState(false);
    const [patient, setPatient] = useState(null);
    return (
        <div className="lander-page">
            <Header websiteUrl={process.env.REACT_APP_WEBSITE_URL} aboutUrl={process.env.REACT_APP_ABOUT_URL} />
            <div className="lander-content">
                {!success ? 
                    <Form onsuccess={(patient) => { setPatient(patient); setSuccess(true)}} /> :
                    <Success patient={patient} />
                }
            </div>
        </div>
    )
}
export default Lander;